import { EApiEndpoint } from 'src/config/enums';
import { apiPostCall } from 'src/services/api/api.core';
import { getCookie } from 'src/utils';

export const contactCallBack = async (data: {
    honorific?: string;
    firstname?: string;
    lastname?: string;
    email?: string;
    clinicId?: number;
    phone?: string;
    query?: string;
    newsletter?: boolean;
    interestedInHair?: boolean;
    interestedInSkin?: boolean;
    hp?: string;
    hpReq?: string;
    eventId?: string;
}): Promise<any> => {
    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc');
    const pageInterest = getCookie('pageinterest');
    const pageUrl = typeof window !== 'undefined' ? window.location.href : undefined;

    const headers: Record<string, string> = {
        ...(fbp && { 'X-Fbp': fbp }),
        ...(fbc && { 'X-Fbc': fbc }),
        ...(data.eventId && { 'X-Fb-Event-Id': data.eventId }),
        ...(pageUrl && { 'X-Page-Url': pageUrl }),
        ...(pageInterest && { 'X-Page-Interest': pageInterest })
    };

    return await apiPostCall(
        EApiEndpoint.FormsContactUs,
        JSON.stringify({
            prefix: data.honorific,
            firstname: data.firstname,
            lastname: data.lastname,
            email: data.email,
            phone: data.phone,
            query: data.query,
            clinic_id: data.clinicId,
            newsletter: data.newsletter,
            interested_in_hair: data.interestedInHair,
            interested_in_skin: data.interestedInSkin
        }),
        {
            alwaysRespond: true,
            headers
        }
    );
};
